import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { GIPNOZIO_ORIGIN, buildSsoUrl, takeDestination } from '../lib/sso';

/**
 * Возврат с гипнозио: в адресе лежит одноразовый тикет.
 *
 * Обмениваем его на сессию гипновейва и сразу вычищаем из адресной строки —
 * тикет уже потрачен, но светить им в истории браузера незачем.
 */
const SsoCallback = () => {
  const { loginWithTicket } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  // React в режиме разработки монтирует компонент дважды; тикет одноразовый,
  // и второй обмен получил бы «уже использован».
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const ticket = new URLSearchParams(window.location.search).get('ticket');
    if (!ticket) {
      setError('В ссылке нет тикета. Попробуйте войти заново.');
      return;
    }

    loginWithTicket(ticket).then((result) => {
      window.history.replaceState({}, '', '/sso/callback');
      if (result.success) {
        // На гипнозио и обратно вкладка уходила целиком, поэтому адрес, куда
        // человек шёл, ждал нас в sessionStorage.
        navigate(takeDestination(), { replace: true });
      } else {
        setError(result.error);
      }
    });
  }, [loginWithTicket, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md text-center">
        {error ? (
          <>
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Не получилось войти</h1>
            <p className="text-gray-600 text-sm mb-6">{error}</p>
            <div className="flex flex-col gap-2">
              <a
                href={buildSsoUrl()}
                className="w-full bg-[#4353FF] text-white py-2 rounded-lg font-medium hover:bg-[#3643DD] transition-colors"
              >
                Войти через Gipnozio
              </a>
              <button
                onClick={() => navigate('/auth', { replace: true })}
                className="w-full text-gray-500 text-sm hover:text-gray-700"
              >
                Войти по логину и паролю
              </button>
            </div>
            {!GIPNOZIO_ORIGIN && (
              <p className="mt-4 text-xs text-gray-400">
                Не задан REACT_APP_GIPNOZIO_ORIGIN — вход через Gipnozio не настроен.
              </p>
            )}
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Входим…</h1>
            <p className="text-gray-600 text-sm">Проверяем ваш аккаунт Gipnozio</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SsoCallback;
